import './sp-column.scss'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Popup } from '../../../../../../../components/popup/popup'
import ApplicantDetails from '../../../../../../applicants-review/applicant-details/applicant-details'
import { TrackedEvent, trackingService } from '../../../../../../../services/tracking-service'
import candidatesIcon from './assets/candidates-icon.svg'
import { useRedirect } from '../../../../../../../services/router'
import { routes } from '../../../../../../../routes'
import { JobScheduleType } from '../../../../../../../models/job'

export type SpColumnProps = {
  name: string
  spId?: number | null
  jobId: number
  imageUrl?: string | null
  isAggregation?: boolean
  applicantsCount?: number
}

export function SpColumn({ imageUrl, name, spId, jobId, isAggregation = false, applicantsCount }: SpColumnProps) {
  const [isProfileShown, setIsProfileShown] = useState(false)
  const redirect = useRedirect()
  const { t } = useTranslation()

  return (
    <div className="SpColumn">
      <img
        onClick={() => {
          if (!isAggregation) {
            setIsProfileShown(true)

            trackingService.track(TrackedEvent.TimesheetSPProfileClicked)
          } else {
            redirect(routes.jobOGCherryPicker, { jobId: String(jobId), type: JobScheduleType.oneTime })
          }
        }}
        src={!isAggregation ? String(imageUrl) : candidatesIcon}
        title={name}
        className="SpColumn__img"
      />
      <div
        onClick={() => {
          if (!isAggregation) {
            setIsProfileShown(true)

            trackingService.track(TrackedEvent.TimesheetSPProfileClicked)
          } else {
            redirect(routes.jobOGCherryPicker, { jobId: String(jobId), type: JobScheduleType.oneTime })
          }
        }}
        className="SpColumn__textContainer"
      >
        <span className="SpColumn__name">{name}</span>
        {isAggregation && (
          <span className="SpColumn__candidates">{`${
            Number(applicantsCount) > 99 ? '99+' : Number(applicantsCount)
          } Candidates`}</span>
        )}
        <span className="SpColumn__id">{t('common.job_n', { id: jobId })}</span>
      </div>
      <Popup
        isActive={isProfileShown}
        content={
          <ApplicantDetails
            jobId={String(jobId)}
            jobType={JobScheduleType.oneTime}
            applicantId={spId as number}
            showHeader={false}
            showControls={false}
          />
        }
        close={() => setIsProfileShown(false)}
      />
    </div>
  )
}
